import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Select from "@components/select";
import { RESIDENTIAL_STATUS_OPTIONS } from "../../../../constants/options";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";
import actions from "@redux/loanForm/actions";

const name = "residentialStatus";

export default function ResidentialStatus({ ...props }) {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  const { initialValue: { loanReason } } = useSelector(state => state.loanForm);
  const dispatch = useDispatch();

  useSetDefaultValue(name);
  usePendingPrefill(name);

  useEffect(()=> {
    if (loanReason === "Bond Loan") {
      dispatch(actions.setFieldInitialValue({[name]: "Renting"}));
    };
  }, [loanReason, dispatch]);

  return (
    <>
      <Select
        isPlaceHolder
        placeholder="Select..."
        title="Describe your residential status"
        options={RESIDENTIAL_STATUS_OPTIONS}
        
        name={name}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        errorMessage={touched[name] ? errors[name] : ""}
      />
    </>
  );
}
